module.exports = ".ck-content .image>figcaption{color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}"


//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/postcss-loader/lib??ref--1-1!../ckeditor5-image/theme/imagecaption.css
// module id = 80
// module chunks = 0